import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';

// CustomSingleValue is a custom function to display the data that is selected in the dropdown
const SingleValue = ({
  data,
  customSingleValue = undefined,
  ...props
}) => {
  const content = useMemo(() => {
    return customSingleValue ? customSingleValue(data) : (
      <div className="flex items-center gap-x-1 min-w-0">
        {data.icon && data.icon}
        <span className="truncate">{data.label}</span>
      </div>
    );
  }, [data, customSingleValue]);

  return <components.SingleValue {...props}>{content}</components.SingleValue>;
};

SingleValue.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    icon: PropTypes.node,
  }).isRequired,
  customSingleValue: PropTypes.func,
};

export default SingleValue;
